import React from 'react';
import { Flex, Skeleton } from 'src/packages/core';

export const HeaderSkeleton = () => (
  <Flex alignItems={'center'} gap={6}>
    <Skeleton
      width={'67px'}
      height={'36px'}
      borderRadius={'6px'}
      theme={'dark'}
      withBorder={true}
    />
    <Skeleton width={'67px'} height={'22px'} theme={'dark'} withBorder={true} />
    <Skeleton width={'67px'} height={'22px'} theme={'dark'} withBorder={true} />
    <Skeleton width={'20px'} height={'24px'} theme={'dark'} withBorder={true} />
  </Flex>
);
